import { CachedRequest } from './base/cachedRequest'
import { endpoint } from './endpoints/def'
import { IGoogleSigninParameters} from 'services/auth/auth.slice'

export const instance = new CachedRequest(1000 * 3)

export async function apiGoogleSigninOneTap(args: IGoogleSigninParameters) {
  return instance.post(endpoint.googleSigninOneTap, args)
}
